var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"i-loader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader spin"},[_c('div',{staticClass:"spin__blocker"}),_c('div',{staticClass:"spin__bottom-left"}),_c('div',{staticClass:"spin__bottom-right"}),_c('div',{staticClass:"spin__top-left"})])
}]

export { render, staticRenderFns }